import layout from '@/views/layout/layout.vue'
const outStockList = r => require.ensure([], () => r(require('@/views/antiChannelConflict/outStock/list.vue')), 'group-antiChannelConflict-outStock')
const outSimpleStockList = r => require.ensure([], () => r(require('@/views/antiChannelConflict/outStock/listSimple.vue')), 'group-antiChannelConflict-outSimpleStock')

const antiChannelConflictOutStock = [
  {
    path: '/antichannelconflict/outstock',
    name: 'antiChannelConflict-outStock',
    component: layout,
    redirect: '/antichannelconflict/outstock/list',
    children: [
      {
        path: 'list',
        component: outStockList,
        name: 'antiChannelConflict-outStock-list',
        meta: {
          displayName: '出库单管理',
          requireAuth: true
        }
      },
      {
        path: 'listsimple',
        component: outSimpleStockList,
        name: 'antiChannelConflict-outStock-listSimple',
        meta: {
          displayName: '出库单管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default antiChannelConflictOutStock



// WEBPACK FOOTER //
// ./src/router/antiChannelConflict/outStock.js